<ng-container>
    <div class="slider-backdrop" (click)="hideSlider()"></div>
    <div class="slider slide">
        <div class="close-icon-container"><button class="btn" (click)="hideSlider()">&#10005;</button></div>
        <b><p [innerHTML]="getSanitizedHtml(supportText.description)"></p></b>
        <ul *ngIf="!!supportText.points">
            <li *ngFor="let point of supportText.points">{{point}}</li>
        </ul>
    </div>
</ng-container>